<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9G0djV/media/FC-9781685627157.jpg?1708094026459" alt="This image is the cover for the book Medicine Park"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Medicine Park
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:16px;font-family:"Bierstadt",sans-serif;'><em>Medicine Park</em> is a compelling small-town murder mystery that takes place in southwestern Oklahoma in the historically pivotal year of 1963.</p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:16px;font-family:"Bierstadt",sans-serif;'>As the town’s high-school history teacher reminds us: “People have lived here all their lives, but they have no idea what goes on beneath the surface.”</p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:16px;font-family:"Bierstadt",sans-serif;'><em>Medicine Park</em> uniquely blends engaging characters, humor, romance, suspense, and Native American tribal culture – with a splash of metaphysics, a dash of the macabre, and an onslaught of surprising twists and turns.</p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:16px;font-family:"Bierstadt",sans-serif;'><em>Buckle up!</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Curry
      </h2>
      
      <p class="authorDescription body article"><p>After graduating from the University of Oklahoma (oh &ndash; so long ago), David bolted to Los Angeles to find something &ndash; anything &ndash; different from the red- dirt predictability of his native land. In California, he eventually found his niche &ndash; writing advertising, TV comedies, and dozens upon dozens of live corporate stage productions.</p><p>Decades later, David returned to his Oklahoma roots to be warmly greeted by family and long-lost friends, plus the cold reality of a pandemic...which gave him more than enough time to write.</p><p>Hence, came up his first novel &ndash; <em>Medicine Park.</em></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?292d4b5c